import * as React from "react";

export const IconGoogle = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clip-path="url(#clip0_162_1148)">
      <path
        d="M19.4316 8.19808C19.5492 8.86681 19.6043 9.55023 19.6043 10.23C19.6043 13.2723 18.5167 15.8443 16.6245 17.586H16.6281C14.971 19.1145 12.6966 20 9.99967 20C6.21879 20 2.76125 17.8689 1.06372 14.4922C-0.354571 11.6666 -0.354573 8.33771 1.06371 5.51215C2.76125 2.13178 6.21879 0.000673866 9.99967 0.000673866C12.4835 -0.0287207 14.8828 0.904557 16.6906 2.60209L13.8357 5.45704C12.8032 4.47232 11.4253 3.93587 9.99967 3.95792C7.3909 3.95792 5.17528 5.71792 4.3853 8.08785C3.96643 9.32977 3.96643 10.6746 4.3853 11.9165H4.38898C5.18263 14.2828 7.39457 16.0428 10.0033 16.0428C11.3518 16.0428 12.5092 15.6974 13.4058 15.0874H13.4021C14.4566 14.3893 15.1768 13.2907 15.4009 12.0488H9.99966V8.19808L19.4316 8.19808Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_162_1148">
        <rect width="20" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
